import { PoetryHub } from "@/src/interface/poems/poetry-hub";

export default function PoemsPage() {
  return <PoetryHub mode="archive" />;
}
